import React, { FC, ReactNode } from "react";
import { isAuthProviderOidc } from "../utils/auth";
import OidcProvider from "./oidc/OidcProvider";
import Auth0ProviderWithRedirect from "./auth0/Auth0ProviderWithRedirect";

const isOidc = isAuthProviderOidc();

type Props = {
  children: ReactNode;
};

const AuthProviderSwitch: FC<Props> = ({ children }) => {
  if (isOidc) {
    return <OidcProvider>{children}</OidcProvider>;
  }

  return <Auth0ProviderWithRedirect>{children}</Auth0ProviderWithRedirect>;
};

export default AuthProviderSwitch;
